module.exports = __webpack_public_path__ + "static/site-sur-mesure-8f615e03b60588f1d225c56efe6801fa.svg";